import n from '../node_modules/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = "\n  .mds-rebuild-tag-binary.mds-rebuild-tag-binary-active {\n    --mds-tag-background-color: var(--info-bg-medium-active);\n    --positive-icon-strong: var(--control-icon-medium-default);\n  }\n.mds-rebuild-tag-binary.mds-rebuild-tag-binary-inactive {\n    --mds-tag-background-color: var(--control-bg-medium-disabled);\n  }\n";
n(css,{"container":"body","singleTag":true,"prepend":true,"attributes":{"id":"@magnetic/tag"}});

export { css, css as default };
//# sourceMappingURL=style.css.js.map
